import { EvaluationException, Expression } from 'ncalcjs';

export function filterPointTypeGeometries(features: any) {
    features.forEach(function (feature: any) {
        const geometryType = feature.geometry.type;
        if (geometryType === "GeometryCollection") {
            //Filter out point type geometries from the geometrycolleciton
            feature.geometry.geometries = feature.geometry.geometries.filter(function (geometry: any) {
                return geometry.type !== "Point";
            });
        }
    });
    return features.filter(function (feature: any) {
        return feature.geometry.type !== "Point";
    });
}

export function cloneLocation(location: any) {
    const newLocation = Object.assign({}, location);
    newLocation.marker = null;
    return newLocation;
}

export function isNumeric(str: string) {
    return !isNaN(Number(str)) && str.trim() !== "";
}

export function generateNCalc(formulaAny: any, extendedProperties: Map<string, any>): string {
    const formula = formulaAny.toString() as string;
    return formula.replace(/\[[a-zA-Z0-9_\s]*\]*/g, function (v: string) {
        let variable = v.toUpperCase().trim();
        variable = variable.slice(1, variable.length - 1);

        const subproperty = extendedProperties.get(variable);
        if (subproperty !== undefined) {
            let numberValue: number | null = subproperty.numberValue;
            if (numberValue == null && subproperty.stringValue == null) {
                numberValue = 0;
            }
            // Don't wrap true and false in '', otherwise these will not be evaluated properly
            let wrapString = true;
            const stringValue: string | null = subproperty.stringValue;
            if (stringValue != null) {
                const stringUpper = stringValue.toUpperCase();
                wrapString = stringUpper !== "TRUE" && stringUpper !== "FALSE";
            }
            
            return stringValue != null ? (wrapString ? `'${stringValue}'` : stringValue) : `${numberValue}`;
        }
        return v;
    });
}

export function evaluateNCalc(formula: any, extendedProperties: Map<string, any>): any { // Can return any type
    return new Expression(generateNCalc(formula, extendedProperties)).Evaluate();
}

export function evaluateNCalcBool(formula: any, extendedProperties: Map<string, any>): boolean { // Always returns a bool
    const result = evaluateNCalc(formula, extendedProperties)
    if (typeof result == "boolean") return result;
    if (typeof result == "number") return result > 0;
    throw new EvaluationException("Cannot convert result to boolean: " + formula);
}

export function evaluateNCalcNumber(formula: any, extendedProperties: Map<string, any>): number { // Always returns a number
    
    const result = evaluateNCalc(formula, extendedProperties)
    if (typeof result == "number") return result;
    if (typeof result == "boolean") return result ? 1 : 0; // True maps to positive, false maps to invisible
    if (!isNaN(result)) return parseFloat(result);
    throw new EvaluationException("Cannot convert result to number: " + formula);
}